import { Component, ElementRef, Input, OnInit } from '@angular/core';

import { ITotal } from '@app/activo2/vacations/components/total-vacations/total-vacations.interface';

@Component({
  selector: 'app-total-vacations-element',
  templateUrl: './total-vacations-element.component.html',
  styleUrls: ['./total-vacations-element.component.scss']
})
export class TotalVacationsElementComponent implements OnInit {
  @Input() totalElement!: ITotal;

  constructor(private elRef: ElementRef) {}

  ngOnInit() {
    if (!this.totalElement || !this.totalElement.dayType) return;

    this.setTotalElementColor();
  }

  private setTotalElementColor() {
    const element = this.elRef.nativeElement;
    element.style.setProperty('--total-color', this.totalElement.dayType.colour);
  }
}
